module.exports = __webpack_public_path__ + "img/city_of_magic_small.a53dd562.png";